import { ObservableProp, useClassStore } from '@Utils/useClassStore';
import { injectable } from 'inversify';
import { action, computed, observable } from 'mobx';
import type { ScaledSize } from 'react-native';

import type { BreakpointsType } from './ScreenSize.types';
import {
  Breakpoints,
  BreakpointsValues,
  breakpointsArray,
} from './ScreenSize.types';

import container from '~ioc/ioc';
import { ScreenSize } from '~types/views-types';

@injectable()
export class ScreenSizeStore {
  @observable size: ScreenSize = ScreenSize.desktop;
  @action setSize = (size: ScreenSize) => {
    this.size = size;
  };

  @observable windowWidth = 0;
  @action setWindowWidth = (width: number) => {
    this.windowWidth = width;
  };

  @observable window = new ObservableProp<ScaledSize>({
    width: 0,
    height: 0,
    scale: 1,
    fontScale: 1,
  });

  //* * Mobile first: thinner to wider breakpoint check */
  @computed get activeBreakpoint() {
    const index = breakpointsArray.findIndex(
      ([_, breakpointWidth]) => this.windowWidth <= breakpointWidth
    );

    return breakpointsArray[index][0];
  }

  isWidthThinnerThan = (breakpoint: BreakpointsType, width?: number) =>
    (width ?? this.windowWidth) <= BreakpointsValues[breakpoint];

  @computed get isBreakpoint(): Record<BreakpointsType, boolean> {
    const breakpoints: Partial<Record<Breakpoints, boolean>> = {};

    // eslint-disable-next-line guard-for-in
    for (const breakpoint in Breakpoints) {
      breakpoints[breakpoint as BreakpointsType] = this.isWidthThinnerThan(
        breakpoint as BreakpointsType
      );
    }

    return breakpoints as Record<BreakpointsType, boolean>;
  }
}

export const useScreenSizeStore = () =>
  useClassStore<ScreenSizeStore>(container.get(ScreenSizeStore));
